export default {
  nav: {
    title: 'Business Documentation Software',
  }
}
